import * as React from "react";
import styles from "./ElectrificationListItem.module.scss";

type ElectrificationListItemProps = {
  enumName: string;
};

const ElectrificationListItem: React.FC<ElectrificationListItemProps> = (
  props: ElectrificationListItemProps
) => {
  const { enumName } = props;

  const mainClasses = [styles.ElectrificationItem];
  return (
    <div className={mainClasses.join(" ")}>
      <div className={styles.ElectrificationItemEnumName}>{enumName}</div>
    </div>
  );
};

export default ElectrificationListItem;
